import { Component } from '@theme/component';

/** Progressive tabs: source content stays readable if JavaScript is unavailable. */
class EvProductStory extends Component {
  #controller;
  #tabs = [];
  #panels = [];

  connectedCallback() {
    super.connectedCallback();
    this.#controller?.abort();
    this.#tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.#panels = this.#tabs.map(tab => this.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`));
    if (!this.#tabs.length || this.#panels.some(panel => !panel)) return;
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.#tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.#select(index), { signal });
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % this.#tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + this.#tabs.length) % this.#tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.#tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this.#select(next);
        this.#tabs[next].focus();
      }, { signal });
      this.#panels[index].setAttribute('role', 'tabpanel');
      this.#panels[index].setAttribute('aria-labelledby', tab.id);
    });
    this.#select(0);
    this.querySelector('[role="tablist"]').hidden = false;
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller?.abort();
  }

  #select(index) {
    this.#tabs.forEach((tab, position) => {
      const selected = position === index;
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
      this.#panels[position].hidden = !selected;
    });
  }
}

if (!customElements.get('ev-product-story')) customElements.define('ev-product-story', EvProductStory);
